import { Header } from "@/types/VDataTable";
export const headers: Header[] = [
  {
    text: "Company",
    type: "string",
    align: "left",
    value: "companyName",
    class: "companyName",
    sortable: true,
  },
  {
    text: "Date Created",
    type: "string",
    align: "left",
    value: "createdDate",
    sortable: true,
    class: "createdDate",
    width: "200px",
  },
  {
    text: "Vessels",
    type: "string",
    align: "left",
    value: "vesselCount",
    sortable: true,
    class: "vesselCount",
    width: "125px",
  },
  {
    text: "Subscription",
    type: "indicator",
    align: "left",
    value: "subscriptionStatus",
    sortable: false,
    class: "subscriptionStatus",
    width: "140px",
  },
  {
    text: "Actions",
    type: "actions",
    align: "left",
    value: "actions",
    sortable: false,
    class: "actions",
    width: "220px",
  },
];
